import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, Image, Loader, Modal, Segment } from 'semantic-ui-react';
import { Elements, StripeProvider } from 'react-stripe-elements';
import Strings from '../../common/Strings';
import { paymentActions } from '../../actions';
import { history } from '../../helpers';
import { isCardExpiring } from '../../helpers/card';
import SettingsCard from './SettingsCard';
import config from '../../config';
import EditCardForm from './EditCardForm';

class PlanAndBillingBillingInformation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      editPaymentModalOpen: false,
      deletePaymentModalOpen: false,
    };
  }

  closeModal = () => {
    this.setState({ editPaymentModalOpen: false });
  };

  renderCardImage = () => {
    const { brand } = this.props.paymentCard;
    if (brand === 'mastercard') {
      return '/cards/mc.png';
    } else if (brand === 'visa') {
      return '/cards/visa.png';
    } else if (brand === 'diners') {
      return '/cards/diner.png';
    } else if (brand === 'amex') {
      return '/cards/amex.png';
    } else if (brand === 'jcb') {
      return '/cards/jcb.png';
    } else if (brand === 'discover') {
      return '/cards/discover.png';
    } else if (brand === 'unionpay') {
      return '/cards/unionpay.png';
    }
    return '/cards/unknown.png';
  };

  renderEditPaymentCardModal() {
    let modalTitle;
    const { paymentCardLoading } = this.props;
    if (this.props.paymentCard) {
      modalTitle = Strings.BILLING.updateCard;
    } else {
      modalTitle = Strings.BILLING.addCard;
    }
    return (
      <Modal
        centered
        size="small"
        open={
          this.state.editPaymentModalOpen && !this.state.deletePaymentModalOpen
        }
        closeIcon={!paymentCardLoading}
        closeOnDimmerClick={!paymentCardLoading}
        onClose={() => {
          this.setState({ editPaymentModalOpen: false });
        }}
      >
        <Modal.Content>
          <div className="common-modal-root">
            <p className="common-modal-title">{modalTitle}</p>
            <div className="plan-and-billing-modal-section">
              <div className="plan-and-billing-modal-section-edit-payment-container">
                <StripeProvider apiKey={config.STRIPE_PUBLIC_KEY}>
                  <Elements>
                    <EditCardForm
                      closeModal={this.closeModal}
                      paymentCard={this.props.paymentCard}
                      openDeleteModal={() => {
                        this.setState({ deletePaymentModalOpen: true });
                      }}
                    />
                  </Elements>
                </StripeProvider>
              </div>
            </div>
          </div>
        </Modal.Content>
        <div className="plan-and-billing-modal-footer">
          <div className="plan-and-billing-modal-footer-card-container">
            <Image
              className="plan-and-billing-modal-footer-stripe"
              src="/stripe.png"
            />
            <Image
              className="plan-and-billing-modal-footer-card"
              src="/cards/small/visa.png"
            />
            <Image
              className="plan-and-billing-modal-footer-card"
              src="/cards/small/amex.png"
            />
            <Image
              className="plan-and-billing-modal-footer-card"
              src="/cards/small/mc.png"
            />
            <Image
              className="plan-and-billing-modal-footer-card"
              src="/cards/small/discover.png"
            />
            <Image
              className="plan-and-billing-modal-footer-card"
              src="/cards/small/jcb.png"
            />
            <Image
              className="plan-and-billing-modal-footer-card"
              src="/cards/small/diner.png"
            />
            <Image
              className="plan-and-billing-modal-footer-card"
              src="/cards/small/unionpay.png"
            />
          </div>
        </div>
      </Modal>
    );
  }

  renderDeletePaymentModal() {
    const deleteCard = () => {
      this.setState({
        deletePaymentModalOpen: false,
        editPaymentModalOpen: false,
      });
      this.props.dispatch(paymentActions.deletePaymentCard());
    };
    return (
      <Modal
        centered
        size="mini"
        open={this.state.deletePaymentModalOpen}
        closeIcon
        onClose={() => {
          this.setState({ deletePaymentModalOpen: false });
        }}
      >
        <div className="plan-and-billing-danger-modal-title">
          {Strings.BILLING.deleteCardTitle}
        </div>
        <div className="common-modal-root plan-and-billing-modal-danger-root">
          <div className="plan-and-billing-modal-section">
            <div className="plan-and-billing-modal-section-danger-container">
              <p className="common-modal-title plan-and-billing-modal-section-danger-title">
                {Strings.BILLING.deleteCardWarning}
              </p>
              <p className="common-modal-body plan-and-billing-modal-section-danger-body">
                {Strings.BILLING.deleteCardWarningDetail}
              </p>
            </div>
          </div>
          <div className="plan-and-billing-modal-button-container">
            <Button
              className="common-grey-button"
              onClick={() => {
                this.setState({ deletePaymentModalOpen: false });
              }}
            >
              {Strings.BILLING.cancel}
            </Button>
            <div style={{ width: 30 }} />
            <Button
              className="common-red-button plan-and-billing-danger-modal-confirm-button"
              onClick={() => {
                deleteCard();
              }}
            >
              {Strings.BILLING.continue}
            </Button>
          </div>
        </div>
      </Modal>
    );
  }

  render() {
    let Content;
    let CardButton;
    if (this.props.paymentCardLoading) {
      Content = (
        <SettingsCard id="plan-and-billing-billing-info-section">
          <Segment basic style={{ margin: 'auto' }}>
            <Loader inline active size="large" />
          </Segment>
        </SettingsCard>
      );
    } else if (this.props.paymentCardFailed) {
      Content = (
        <SettingsCard id="plan-and-billing-billing-info-section">
          <div
            style={{
              marginLeft: 'auto',
              marginRight: 'auto',
              textAlign: 'center',
              display: 'inline-block',
            }}
          >
            <Image
              src="/error/billing_information_error.png"
              className="plan-and-billing-error-image"
              style={{ transform: 'translateX(12%)' }}
            />
            <p className="plan-and-billing-error-text">
              {Strings.BILLING.paymentCardError}
            </p>
            <Button
              className="common-light-button"
              onClick={() => {
                this.props.dispatch(paymentActions.getPaymentCards());
              }}
            >
              {Strings.BILLING.refresh}
            </Button>
          </div>
        </SettingsCard>
      );
    } else if (this.props.paymentCard) {
      const expiring = this.props.paymentCardExpiring;
      const WarningImage = expiring ? (
        <Image
          className="plan-and-billing-card-image-alert"
          src="/error/icon_alert.png"
        />
      ) : (
        ''
      );
      Content = (
        <SettingsCard id="plan-and-billing-billing-info-section">
          <div className="plan-and-billing-card-row">
            <div
              style={{
                position: 'relative',
              }}
            >
              <Image
                className="plan-and-billing-card-image"
                src={this.renderCardImage()}
              />
              {WarningImage}

              <p className="plan-and-billing-card-row-value-bold">
                **** **** **** {this.props.paymentCard.last4}
              </p>
            </div>
          </div>
          <div className="plan-and-billing-card-row">
            <p className="settings-card-subtitle">
              {Strings.BILLING.billingEmail}
            </p>
            <p className="plan-and-billing-card-row-value">
              {this.props.email}
            </p>
          </div>
          <div className="plan-and-billing-card-row">
            <p className="settings-card-subtitle">
              {Strings.BILLING.expiration}
            </p>
            <p
              className="plan-and-billing-card-row-value"
              style={{ color: expiring ? '#FE6868' : '' }}
            >
              {this.props.paymentCard.expMonth} /{' '}
              {this.props.paymentCard.expYear}
            </p>
          </div>
        </SettingsCard>
      );
      CardButton = (
        <Button
          className="common-green-button-small"
          style={{
            marginLeft: 'auto',
            marginBottom: 10,
          }}
          onClick={() => {
            this.setState({ editPaymentModalOpen: true });
          }}
        >
          {Strings.BILLING.updateCard}
        </Button>
      );
    } else {
      Content = (
        <SettingsCard id="plan-and-billing-billing-info-section">
          <div
            className="plan-and-billing-card-empty"
            onClick={() => {
              if (this.props.customerId)
                this.setState({ editPaymentModalOpen: true });
              else history.push('#premium');
            }}
          >
            <Image
              className="plan-and-billing-card-empty-plus"
              src="/icon/plus.svg"
            />
          </div>
        </SettingsCard>
      );
      CardButton = (
        <Button
          className="common-green-button-small"
          style={{
            marginLeft: 'auto',
          }}
          onClick={() => {
            if (this.props.customerId)
              this.setState({ editPaymentModalOpen: true });
            else history.push('#premium');
          }}
        >
          {Strings.BILLING.addCard}
        </Button>
      );
    }
    return (
      <div>
        <div className="plan-and-billing-billing-title">
          <p className="settings-card-title">
            {Strings.BILLING.billingInformation}
          </p>
          {CardButton}
        </div>
        {Content}
        {this.renderEditPaymentCardModal()}
        {this.renderDeletePaymentModal()}
      </div>
    );
  }
}

PlanAndBillingBillingInformation.defaultProps = {
  paymentCard: null,
  email: '',
  customerId: null,
};

PlanAndBillingBillingInformation.propTypes = {
  dispatch: PropTypes.func.isRequired,
  email: PropTypes.string,
  customerId: PropTypes.string,
  paymentCard: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    last4: PropTypes.string.isRequired,
    brand: PropTypes.string.isRequired,
    expMonth: PropTypes.number.isRequired,
    expYear: PropTypes.number.isRequired,
  }),
  paymentCardExpiring: PropTypes.bool.isRequired,
  paymentCardLoading: PropTypes.bool.isRequired,
  paymentCardFailed: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  email: state.user.email,
  customerId: state.user.stripe && state.user.stripe.customerId,
  paymentCard: state.paymentCards.card,
  paymentCardExpiring: isCardExpiring(
    state.paymentCards.card,
    state.upcomingInvoice.upcoming,
  ),
  paymentCardLoading: state.paymentCards.loading,
  paymentCardFailed: state.paymentCards.failed,
});

export default connect(mapStateToProps)(PlanAndBillingBillingInformation);



// WEBPACK FOOTER //
// ./src/components/settings/PlanAndBillingBillingInformation.js